function formatPrice(number) {
  const number_to_string = number?.toString();
  let integer = parseInt(number_to_string);
  if (isNaN(integer)) integer = 0;
  // Convert the number to a string and reverse it
  const reversedNumberString = String(integer).split("").reverse().join("");

  // Use a regular expression to add a space every 3 digits
  const formattedNumber = reversedNumberString
    .replace(/(\d{3})/g, "$1 ")
    .trim();

  // Reverse it back to its original order
  return formattedNumber.split("").reverse().join("");
}

function getDiscountPercentage(price, promotion_price) {
  const discount = Math.floor(((price - promotion_price) / price) * 100);
  return discount;
}

function formatDateYMD(date) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function formatDateToDayMonthYear(dateString) {
  const date = new Date(dateString);

  // Options pour formater la date
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };

  // Formater la date
  return date.toLocaleDateString("fr-FR", options);
}

function filterHomeProductData(data) {
  let filteredData;
  if (data && Array.isArray(data)) {
    filteredData = data?.filter((item) => item.fee !== undefined);

    filteredData.sort((a, b) => a.fee - b.fee);

    filteredData?.sort((a, b) => b.points - a.points);

    filteredData?.sort((a, b) => b.is_open - a.is_open);
  }
  return filteredData;
}

function arrondirParMultiple(points, cartAmount, _multiple = 500) {
  const multiple = _multiple || 500;

  const maxPossible = Math.floor(cartAmount / multiple) * multiple;
  return Math.min(Math.floor(points / multiple) * multiple, maxPossible);
}

const getCheckoutConfirmation = (url) => {
  const [https, slash, domaineName, ...res] = url.split("/");

  return [https, slash, domaineName].join("/");
};

const getMonthName = (monthNumber) => {
  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  // Soustraire 1 car les tableaux commencent à 0 mais les mois commencent à 1
  return months[monthNumber - 1];
};

/**
 * Vérifie si une durée est dépassée à partir d'une date donnée.
 *
 * @param {Date|string} date - La date de départ (objet Date ou string).
 * @param {number} valeur - La quantité de temps à comparer.
 * @param {"M" | "H" | "D"} unite - L'unité de temps.
 * @returns {boolean} - True si le délai est dépassé, sinon false.
 */
function estDelaiDepasse(date, valeur, unite) {
  const dateDepart = new Date(date);
  const maintenant = new Date();

  let delaiMs = 0;

  switch (unite) {
    case "M":
      delaiMs = valeur * 60 * 1000;
      break;
    case "H":
      delaiMs = valeur * 60 * 60 * 1000;
      break;
    case "D":
      delaiMs = valeur * 24 * 60 * 60 * 1000;
      break;
    default:
      throw new Error("Unité invalide : choisir 'M', 'H' ou 'D'");
  }

  return maintenant.getTime() - dateDepart.getTime() < delaiMs;
}

const getWebsiteUrl = (domaine) => {
  const currentDomain =
    window.location.hostname === "localhost"
      ? "puff.sn"
      : window.location.hostname;
  return `https://${domaine}.${currentDomain}`;
};

export {
  formatPrice,
  getDiscountPercentage,
  formatDateToDayMonthYear,
  formatDateYMD,
  filterHomeProductData,
  arrondirParMultiple,
  getCheckoutConfirmation,
  getMonthName,
  estDelaiDepasse,
  getWebsiteUrl,
};
